module.exports = __webpack_public_path__ + "img/LMLOGO.26bbc070.webp";